
import HeartSlash from "../../../assets/outline/HeartSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HeartSlashIcon({ className, dataTestid = "HeartSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HeartSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
